export { default } from './CustomEmblaCarouselHome24';
